import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import useFormProcessor from '../../hooks/useFormProcessor';

import { getCookie } from '../../utils/cookie';

import { ProjectsContext } from '../../providers/projects-context.provider';

import { createTeam } from '../../services/teams.service';
import { getEmptyInputsErrorsObject } from '../../utils/errors/teams';
import { validateTitle } from '../../utils/validations/teams';

import ErrorMessageContainer from '../form-input-error-message';

import FormInput from '../form-input';
import FormButton from '../button-form';

const initialTeam = {
	Title: ''
};

const CreateTeamForm = () => {
	const history = useHistory();
	const { data, errors, handleChange, handleOnBlur, handleSubmit } = useFormProcessor(initialTeam, initialTeam);
	const { currentProject } = useContext(ProjectsContext);

	const getErrors = () => {
		const { Title } = data;
		return getEmptyInputsErrorsObject({ Title });
	};

	const handleCreateTeam = async () => {
		const token = getCookie('x-auth-token');
		const result = await createTeam(currentProject.Id, token, { Title: data.Title, ImageUrl: '' });
		if (result) {
			//history.push(`/user/teams/${result}`);
			history.push(`/user/dashboard/${currentProject.Id}/teams`);
		}
	};

	return (
		<form
			onSubmit={(e) => handleSubmit(e, getErrors(), handleCreateTeam)}
			className="lg:w-2/6 md:w-1/2 rounded-lg p-8 flex flex-col md:ml-0 w-full mt-10 md:mt-0"
		>
			<h2 className="text-gray-900 text-lg font-medium title-font mb-5">ایجاد تیم</h2>
			<FormInput
				handleChange={handleChange}
				handleOnBlur={(event) => handleOnBlur(event, validateTitle, { Title: data.Title })}
				type="text"
				name="Title"
				value={data.Title}
				placeholder="نام تیم"
			/>
			{errors.Title ? <ErrorMessageContainer>{errors.Title}</ErrorMessageContainer> : null}
			<FormButton addClass="mt-4">ایجاد</FormButton>
		</form>
	);
};

export default CreateTeamForm;
